import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-16 md:py-24 px-6 bg-brand-card" data-id="element-119">
      <div className="max-w-4xl mx-auto" data-id="element-120">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="flex flex-col md:flex-row gap-8 md:gap-12 items-start" data-id="element-121">
          <div className="md:w-1/3 flex justify-center md:justify-start" data-id="element-122">
            <div className="bg-brand-surface p-6 rounded-2xl border border-brand-red/20" data-id="element-123">
              <AlertTriangle className="w-16 h-16 text-brand-red mb-4" aria-hidden="true" data-id="element-124" />
              <h3 className="font-heading font-bold text-2xl uppercase text-brand-text" data-id="element-125">
                La Trampa del Estrés
              </h3>
            </div>
          </div>

          <div className="md:w-2/3 space-y-6 font-body text-lg text-brand-muted leading-relaxed" data-id="element-126">
            <h2 className="font-heading font-bold text-3xl md:text-4xl text-brand-text uppercase leading-tight" data-id="element-127">
              El estilo de vida de alta presión en Estados Unidos está diseñado
              para <span className="text-brand-red" data-id="element-128">triturar tu hombría.</span>
            </h2>

            <p data-id="element-129">
              El estrés constante del tráfico, las cuotas de ventas y las
              facturas elevan una hormona llamada{' '}
              <strong className="text-brand-text font-semibold" data-id="element-130">
                Cortisol
              </strong>
              .
            </p>

            <p data-id="element-131">
              Cuando el Cortisol sube, tu{' '}
              <strong className="text-brand-accent font-semibold" data-id="element-132">
                Testosterona cae en picada
              </strong>
              . Tu cuerpo entra en "modo supervivencia", almacenando grasa
              precisamente en la cintura y apagando tu deseo y tu energía para
              que simplemente puedas "aguantar" el día.
            </p>

            <blockquote className="border-l-4 border-brand-accent pl-6 py-2 my-8" data-id="element-133">
              <p className="font-heading font-bold text-2xl text-brand-text uppercase tracking-wide" data-id="element-134">
                "No estás viejo; estás hormonalmente bloqueado por el estrés."
              </p>
            </blockquote>
          </div>
        </motion.div>
      </div>
    </section>;
}